import PropTypes from "prop-types";
import React from "react";
import { getNewSiteUrl, getPrivacyUrl } from "../data/newSiteConfig";

const Footer = ({ home_link, content, langkey }) => (
  <footer>
    <div className="container">
      <div className="footer--left">
        © {new Date().getFullYear()} AYANA HOSPITALITY. ALL RIGHTS RESERVED |{" "}
        <a
          href={getNewSiteUrl("terms-and-conditions-8", langkey)}
          style={{ color: "#fff" }}>
          {content.footer_link_tos}
        </a>{" "}
        |{" "}
        <a
          href={getPrivacyUrl(langkey)}
          style={{ color: "#fff" }}>
          {content.footer_link_privacy_policies}
        </a>
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  props: PropTypes.string,
};

Footer.defaultProps = {
  props: ``,
};

export default Footer;
